module.exports = __webpack_public_path__ + "img/860-a43c11.png";